<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: pingping.mao
 * @LastEditTime: 2022-10-14 18:32:03
-->
<template>
  <div class="img_bg_develop_4">
    <img
      style="height: 50%; margin: 0 auto; opacity: 0.5"
      src="@/assets/images/developing.png"
    />
  </div>
  <!-- <div class="wscn-http-container">
    <div class="wscn-http">
      <img class="pic__parent" src="@/assets/images/developing.png" alt="404" />
    </div>
    <div class="not-find-descrition">首页建设中，敬请期待...</div>
  </div> -->
</template>

<script>
export default {
  name: "PageDeveloping"
};
</script>

<style lang="scss" scoped>
.wscn-http-container {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 40%;
  left: 50%;
  text-align: center;
  overflow: hidden;
}
.wscn-http {
  width: 200px;
  margin-bottom: 20px;
  .pic {
    float: left;
    width: 100px;
    overflow: hidden;
    &__parent {
      width: 100%;
    }
  }
}
.not-find-descrition {
  font-size: 14px;
}
.img_bg_develop_4{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  // opacity: 0.5;
}
</style>
